import { render, staticRenderFns } from "./ConfirmPhone.vue?vue&type=template&id=6ba132c4&lang=pug&"
import script from "./ConfirmPhone.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports